import { ReactNode } from "react";
import { Params, useParams } from "react-router-dom";
import { LinkOpeningProblemAlert } from "./LinkOpeningProblemAlert";

interface Props {
  nodeExpectingIdentifier: (playlistIdentifier: string) => ReactNode;
}

export const paramKey = "id";

export function ParamValidatorId(props: Props) {
  const params: Readonly<Params<string>> = useParams();

  const optUuid = params[paramKey];

  function validateAndRender(): ReactNode {
    if (optUuid === undefined)
      return (
        <LinkOpeningProblemAlert>
          Der notwendige Identifier fehlt.
        </LinkOpeningProblemAlert>
      );

    return props.nodeExpectingIdentifier(optUuid);
  }

  return validateAndRender();
}
